var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptimisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000061434770408699399780000012845254712904248193_);}\r\n\t.st2{fill:url(#SVGID_00000103971817886841750010000003630156542139491745_);}\r\n\t.st3{fill:url(#SVGID_00000018927106871327489950000012143148004573800591_);}\r\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 350.019,
    cy: 339.3707,
    r: 445.0568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    style: {
      stopColor: "#E5C6A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#D5A983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7632,
    style: {
      stopColor: "#A57B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8977,
    style: {
      stopColor: "#D5A983"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.94,377.78c0.72-2.92,2.8-5.32,5.6-6.43l33.05-13.21l0,0c0.88-0.34,1.53-1.11,1.7-2.04 c0.99-11.12,0.99-22.31,0-33.43c-0.14-0.98-0.81-1.8-1.73-2.16l-33.01-13.2c-2.8-1.12-4.88-3.51-5.6-6.43 c-3.83-15.45-9.96-30.24-18.2-43.87c-1.55-2.57-1.77-5.73-0.59-8.49l14-32.75c0.43-0.84,0.36-1.84-0.18-2.61 c-3.14-3.82-6.75-7.77-11.41-12.56c-4.6-4.49-8.56-8.09-12.27-11.2v0c-0.78-0.6-1.82-0.7-2.7-0.27l-32.76,14h0 c-2.76,1.18-5.92,0.96-8.5-0.59c-13.62-8.24-28.41-14.38-43.87-18.2c-2.92-0.72-5.31-2.81-6.43-5.6l-13.22-32.98 c-0.33-0.88-1.09-1.52-2.01-1.7c-11.12-0.99-22.31-0.99-33.43,0c-0.98,0.14-1.8,0.81-2.16,1.74l-13.22,32.98 c-1.12,2.8-3.51,4.88-6.43,5.6c-15.45,3.83-30.24,9.96-43.87,18.2c-2.57,1.55-5.73,1.77-8.49,0.59l-32.75-14 c-0.84-0.42-1.83-0.35-2.61,0.18c-3.82,3.14-7.77,6.75-12.55,11.41c-4.49,4.6-8.09,8.56-11.2,12.27h0c-0.59,0.78-0.7,1.82-0.27,2.7 l14,32.76v0c1.18,2.76,0.96,5.92-0.59,8.5c-8.24,13.62-14.38,28.41-18.2,43.87c-0.72,2.92-2.81,5.31-5.6,6.43l-32.98,13.22 c-0.88,0.34-1.53,1.11-1.7,2.04c-0.99,11.12-0.99,22.31,0,33.43c0.14,0.98,0.81,1.8,1.74,2.16l32.98,13.2 c2.8,1.12,4.88,3.51,5.6,6.43c3.83,15.45,9.96,30.24,18.2,43.87c1.55,2.57,1.77,5.73,0.59,8.49l-14,32.75 c-0.43,0.84-0.36,1.84,0.18,2.61c3.14,3.82,6.75,7.77,11.41,12.55c4.6,4.49,8.56,8.09,12.27,11.2v0c0.78,0.59,1.82,0.7,2.7,0.27 l32.76-14h0c2.77-1.17,5.92-0.95,8.5,0.59c13.62,8.24,28.41,14.38,43.87,18.2c2.92,0.72,5.31,2.81,6.43,5.6l13.21,33.05 c0.33,0.88,1.11,1.53,2.04,1.7c11.12,0.99,22.31,0.99,33.43,0c0.98-0.14,1.81-0.81,2.16-1.74l13.21-33.05 c1.12-2.8,3.51-4.88,6.43-5.6c15.45-3.83,30.24-9.96,43.87-18.2c2.57-1.55,5.73-1.77,8.49-0.59l32.75,14 c0.84,0.41,1.83,0.34,2.61-0.18c3.82-3.14,7.77-6.75,12.55-11.41c4.49-4.6,8.09-8.56,11.2-12.27h0c0.59-0.78,0.7-1.82,0.27-2.7 l-14-32.76v0c-1.18-2.76-0.96-5.92,0.59-8.5C495,408.03,501.13,393.24,504.94,377.78L504.94,377.78z M350.01,470.01 c-34.66,0-67.89-13.77-92.39-38.27c-24.5-24.5-38.27-57.74-38.27-92.39s13.77-67.89,38.27-92.39c24.5-24.5,57.74-38.27,92.39-38.27 s67.89,13.77,92.39,38.27c24.5,24.5,38.27,57.74,38.27,92.39c-0.04,34.64-13.82,67.86-38.31,92.36S384.65,469.97,350.01,470.01 L350.01,470.01z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000151533075992622542360000013008298334419490461_",
    cx: 295.3702,
    cy: 381.3347,
    r: 231.7487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    style: {
      stopColor: "#E5C6A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#D5A983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7632,
    style: {
      stopColor: "#A57B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8977,
    style: {
      stopColor: "#D5A983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151533075992622542360000013008298334419490461_)"
    },
    d: "M350.01,619.33 c60.16,0.2,118.75-19.15,166.95-55.14c4.12-3.09,4.96-8.95,1.87-13.07c-3.09-4.12-8.94-4.96-13.07-1.87 c-44.97,33.57-99.64,51.61-155.75,51.41c-65.73-0.01-129.04-24.78-177.32-69.4c-48.27-44.61-77.97-105.77-83.16-171.29 c-5.19-65.52,14.5-130.6,55.15-182.25v21.6c0,5.16,4.18,9.33,9.33,9.33s9.33-4.18,9.33-9.33v-46.67c0-2.47-0.98-4.85-2.73-6.6 c-1.75-1.75-4.12-2.73-6.6-2.73h-46.67c-5.15,0-9.33,4.18-9.33,9.33c0,5.16,4.18,9.34,9.33,9.34h26.13 c-45.04,54.95-67.5,124.98-62.82,195.88c4.68,70.89,36.15,137.36,88.02,185.91C210.55,592.34,278.96,619.35,350.01,619.33 L350.01,619.33z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000177482928870277113410000002548281405827105960_",
    cx: 404.6488,
    cy: 297.3354,
    r: 231.7515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    style: {
      stopColor: "#E5C6A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#D5A983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7632,
    style: {
      stopColor: "#A57B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8977,
    style: {
      stopColor: "#D5A983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177482928870277113410000002548281405827105960_)"
    },
    d: "M350.01,59.33 c-60.16-0.2-118.75,19.15-166.95,55.14c-4.12,3.09-4.96,8.95-1.87,13.07c3.09,4.12,8.94,4.96,13.07,1.87 C239.23,95.84,293.89,77.8,350.01,78c65.71-0.09,129.03,24.62,177.32,69.18s78,105.7,83.19,171.2 c5.2,65.5-14.51,130.55-55.18,182.17v-21.21c0-5.16-4.18-9.33-9.33-9.33s-9.33,4.18-9.33,9.33v46.67c0,2.47,0.98,4.85,2.73,6.6 c1.75,1.75,4.12,2.73,6.6,2.73h46.67c5.15,0,9.33-4.18,9.33-9.33c0-5.16-4.18-9.34-9.33-9.34h-26.13 c45.05-54.95,67.51-124.98,62.83-195.88c-4.68-70.9-36.15-137.37-88.03-185.92C489.46,86.32,421.06,59.32,350.01,59.33L350.01,59.33 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000021082719430475219640000008850279632740035006_",
    cx: 343.3053,
    cy: 336.0192,
    r: 189.6331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    style: {
      stopColor: "#E5C6A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#D5A983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7632,
    style: {
      stopColor: "#A57B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8977,
    style: {
      stopColor: "#D5A983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021082719430475219640000008850279632740035006_)"
    },
    d: "M394.21,364.38l14.44,13.92 c-11.14,13.23-28.19,20.36-48.2,20.36c-30.8,0-55.16-17.92-62.65-44.55h-19.84v-12.18l17.58,0c-0.17-1.91-0.17-3.83-0.17-5.92 c0-2.09,0-4,0.17-5.92h-17.58v-12.18h19.84c7.48-26.62,31.85-44.55,62.65-44.55c20.01,0,37.07,7.14,48.2,20.36l-14.44,13.75 c-8.88-9.57-19.84-14.27-32.54-14.27c-18.62,0-33.41,9.57-40.02,24.71h49.94v12.18h-53.25c-0.17,1.91-0.35,3.83-0.35,5.92 c0,2.09,0.17,4,0.35,5.92h53.25v12.18h-49.94c6.61,15.14,21.4,24.71,40.02,24.71C374.37,378.83,385.33,374.13,394.21,364.38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimisation);
export default __webpack_public_path__ + "static/media/optimisation.6439c6d0edfd8ab82b55d99517903d4c.svg";
export { ForwardRef as ReactComponent };